// components/RecentTransactionsTable.js
import React from "react";
import {
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableRow,
  Typography,
  Chip,
  Box,
} from "@mui/material";
import { useTranslation } from "react-i18next";

const RecentTransactionsTable = ({ transactions }) => {
  const { t } = useTranslation();

  const formatDate = (dateString) => {
    if (!dateString) return t("common.noData");

    try {
      const date = new Date(dateString);
      return date.toString() !== "Invalid Date"
        ? date.toLocaleDateString()
        : t("common.noData");
    } catch (error) {
      console.error("Date formatting error:", error);
      return t("common.noData");
    }
  };

  const formatAmount = (amount) => {
    return new Intl.NumberFormat("en-US", {
      style: "currency",
      currency: "USD",
      signDisplay: "always",
    }).format(amount);
  };

  const getStatusColor = (status) => {
    switch (status) {
      case "completed":
        return "success";
      case "pending":
        return "warning";
      case "failed":
        return "error";
      default:
        return "default";
    }
  };

  if (!transactions || transactions.length === 0) {
    return (
      <Box sx={{ p: 2, textAlign: "center" }}>
        <Typography color="textSecondary">
          {t("transactions.noTransactions")}
        </Typography>
      </Box>
    );
  }

  return (
    <Table size="small">
      <TableHead>
        <TableRow>
          <TableCell>{t("transactions.columns.date")}</TableCell>
          <TableCell>{t("transactions.columns.type")}</TableCell>
          <TableCell>{t("transactions.columns.amount")}</TableCell>
          <TableCell>{t("transactions.columns.status")}</TableCell>
        </TableRow>
      </TableHead>
      <TableBody>
        {transactions.map((transaction) => (
          <TableRow key={transaction.id}>
            <TableCell>
              {formatDate(transaction.created_at || transaction.createdAt)}
            </TableCell>
            <TableCell>
              {t(`transactions.types.${transaction.type}`, {
                defaultValue: transaction.type.replace("_", " ").toUpperCase(),
              })}
            </TableCell>
            <TableCell>{formatAmount(transaction.amount)}</TableCell>
            <TableCell>
              <Chip
                label={t(`status.${transaction.status}`, {
                  defaultValue: transaction.status.toUpperCase(),
                })}
                color={getStatusColor(transaction.status)}
                size="small"
              />
            </TableCell>
          </TableRow>
        ))}
      </TableBody>
    </Table>
  );
};

export default RecentTransactionsTable;
